import { educationSubjects, groupedTopics } from "./educationCatalog";

export type NavItem = {
  label: string;
  href?: string;
  icon: string;
  expanded?: boolean;
  children?: NavItem[];
};

const subjectNav = (slug: string): NavItem | undefined => {
  const subject = educationSubjects.find((item) => item.slug === slug);
  if (!subject) return undefined;
  return {
    label: subject.title,
    icon: subject.icon,
    children: [
      { label: "Panoramica", href: subject.href, icon: "home" },
      ...groupedTopics(slug).map((group) => ({
        label: group.area,
        icon: subject.icon,
        children: group.topics.map((topic) => ({
          label: topic.title,
          href: topic.href,
          icon: subject.icon
        }))
      }))
    ]
  };
};

const requiredSubjectNav = (slug: string): NavItem => subjectNav(slug) ?? { label: slug, href: `/education/${slug}`, icon: "book" };

export const navItems: NavItem[] = [
  { label: "Home", href: "/", icon: "home" },
  {
    label: "Quiz",
    icon: "quiz",
    expanded: true,
    children: [
      { label: "Nuovo", href: "/quiz", icon: "play" },
      { label: "Catalogo quiz", href: "/quiz/catalogo", icon: "library" },
      { label: "Le mie statistiche", href: "/quiz/statistiche", icon: "chart" },
      { label: "Storico", href: "/quiz/result", icon: "history" }
    ]
  },
  {
    label: "Programmi",
    icon: "book",
    children: [
      { label: "Primaria", href: "/programmi-didattici?scuola=primaria", icon: "school" },
      { label: "Secondaria", href: "/programmi-didattici?scuola=secondaria", icon: "school" },
      { label: "Superiori", href: "/programmi-didattici?scuola=superiori", icon: "school" },
      { label: "Universita", href: "/programmi-didattici?scuola=universita", icon: "school" }
    ]
  },
  { label: "Didattica", href: "/programma-didattico", icon: "book" },
  { label: "Piano settimanale", href: "/study-program/weekly-schedule", icon: "calendar" },
  {
    label: "Memoria",
    icon: "brain",
    children: [
      { label: "Teoria", href: "/education/memory", icon: "book" },
      { label: "Giochi", href: "/education/memory/games", icon: "game" }
    ]
  },
  {
    label: "Materie",
    icon: "school",
    children: [
      requiredSubjectNav("italian"),
      requiredSubjectNav("mathematics"),
      {
        label: "Storia",
        icon: "history",
        children: [
          { label: "Panoramica", href: "/education/history", icon: "home" },
          { label: "Timeline storica", href: "/education/history/timeline", icon: "timeline" },
          { label: "Antichita", href: "/education/history/timeline?epoch=ancient", icon: "landmark" },
          { label: "Medioevo", href: "/education/history/timeline?epoch=middle-ages", icon: "castle" },
          { label: "Eta Moderna", href: "/education/history/timeline?epoch=modern-era", icon: "flask" },
          { label: "Eta Contemporanea", href: "/education/history/timeline?epoch=contemporary", icon: "globe" }
        ]
      },
      requiredSubjectNav("geography"),
      requiredSubjectNav("science"),
      requiredSubjectNav("physics"),
      requiredSubjectNav("music"),
      requiredSubjectNav("english"),
      requiredSubjectNav("spanish"),
      requiredSubjectNav("chinese"),
      requiredSubjectNav("japanese"),
      requiredSubjectNav("informatica"),
      requiredSubjectNav("biology")
    ]
  },
  { label: "Conoscenza", href: "/education/knowledge", icon: "sparkles" },
  {
    label: "Admin",
    icon: "admin",
    children: [
      { label: "Generatore", href: "/admin/quiz-generator", icon: "sparkles" },
      { label: "Batch", href: "/admin/quiz-batch", icon: "stack" },
      { label: "Analytics", href: "/admin/quiz-analytics", icon: "chart" },
      { label: "LLM", href: "/admin/llm-settings", icon: "bot" }
    ]
  },
  { label: "Build", href: "/admin/builds", icon: "monitor" },
  {
    label: "Studenti",
    icon: "users",
    expanded: true,
    children: [
      { label: "Nuovo", href: "/student/register", icon: "user-plus" },
      { label: "Studenti", href: "/student/list", icon: "users" },
      { label: "Nuova insegnante", href: "/teacher/register", icon: "user-plus" },
      { label: "Insegnanti", href: "/teacher/list", icon: "users" },
      { label: "Accessi dispositivi", href: "/admin/user-access", icon: "settings" }
    ]
  },
  { label: "Signout", href: "/", icon: "logout" }
];
